import './css/site.css';
import './css/Login.css';
import './css/forms.css';
import 'react-big-calendar/lib/css/react-big-calendar.css'
import 'bootstrap';
import 'hammerjs';
import './css/registration.css';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { AppContainer } from 'react-hot-loader';
import { Provider } from 'react-redux';
import configureStore from './configureStore';
import { ApplicationState } from './store';
import * as RoutesModule from './routes';
import * as Sentry from '@sentry/react';
import SentryErrorBoundary from './components/SentryErrorBoundary';
import { version } from './version';

let routes = RoutesModule.routes;

// Configure Sentry
Sentry.init({
    release: `daycarium@${version}`,
    enabled: window.location.hostname !== "localhost",
    dsn: "https://b78d211eee72413393d9f8d542bdc9a5@o261143.ingest.sentry.io/1458640"
});

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = (window as any).initialReduxState as ApplicationState;
initialState.authentication.token = localStorage.getItem("ACCESS_TOKEN") || '';
const store = configureStore(initialState);

function renderApp() {
    // This code starts up the React app when it runs in a browser. It sets up the routing configuration
    // and injects the app into a DOM element.
    ReactDOM.render(
        <AppContainer>
            <SentryErrorBoundary>
                <Provider store={ store }>
                    <BrowserRouter children={ routes } />
                </Provider>
            </SentryErrorBoundary>
        </AppContainer>,
        document.getElementById('react-app')
    );
}

renderApp();

// Allow Hot Module Replacement
if (module.hot) {
    module.hot.accept('./routes', () => {
        routes = require<typeof RoutesModule>('./routes').routes;
        renderApp();
    });
}
